import { render } from "./MemberDesign.vue?vue&type=template&id=0443975c"
import script from "./MemberDesign.vue?vue&type=script&lang=js"
export * from "./MemberDesign.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__